import { gql } from '@apollo/client';
import { client } from 'graphql/client';

export const CHECK_DELIVERY_DRIVER_UNIQUENESS = gql`
    query CheckDeliveryDriverUniqueness($phone: String, $idDocumentNumber: String, $excludeAccountId: Long) {
        checkDeliveryDriverUniqueness(phone: $phone, idDocumentNumber: $idDocumentNumber, excludeAccountId: $excludeAccountId) {
            messageKey
            details
        }
    }
`;

export interface DriverUniquenessConflict {
    messageKey: string;
    // JSON 字符串
    details: string;
}

interface CheckDeliveryDriverUniquenessResponse {
    checkDeliveryDriverUniqueness: DriverUniquenessConflict | null;
}

export interface CheckDeliveryDriverUniquenessVariables {
    phone?: string | null;
    idDocumentNumber?: string | null;
    excludeAccountId?: string | number | null;
}

export const checkDeliveryDriverUniqueness = async (
    variables: CheckDeliveryDriverUniquenessVariables
): Promise<DriverUniquenessConflict | null> => {
    const { data } = await client.query<CheckDeliveryDriverUniquenessResponse>({
        query: CHECK_DELIVERY_DRIVER_UNIQUENESS,
        variables,
        fetchPolicy: 'network-only',
    });
    return data?.checkDeliveryDriverUniqueness ?? null;
};
